import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';
import { api, AUTH_URL, getClientAuthorization } from 'pages/APIs';
export default class OrgApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public get(): Promise<any> {
    return super.get(api.get_org_info, {});
  }

  public set(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.put(api.set_org_info, formData);
  }
}
